// import React from "react";
// import { Typography } from "antd";
// import SidebarLayout from "./SidebarLayout";

// const { Title } = Typography;

// const DataInsights = () => {
//     return (
//         <SidebarLayout>
//             <Title level={3}>Data Insights</Title>
//             <div style={{
//                 display: 'flex',
//                 flexDirection: 'column',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 textAlign: 'center',
//                 marginTop: '100px'
//             }}>
//                 <img
//                     src="/constructionhat2.png"
//                     alt="LEVRIDGE.AI"
//                     style={{
//                         margin: '20px 0',
//                         display: 'block',
//                         maxWidth: '14%',
//                     }}
//                 />
//                 <div className="underconstruciton-box">
//                     <h2>Under construction</h2>
//                 </div>
//             </div>
//         </SidebarLayout>
//     );

// }

// export default DataInsights;


import React, { useEffect, useState } from "react";
import { Typography, Spin,Input, Button, Form } from "antd";
import { SendOutlined } from "@ant-design/icons";
import SidebarLayout from "../BankerUI/SidebarLayout";
import EchoChat from "../NewApplication/EchoChat";
import EchoChatForAdmin from "../NewApplication/EchoChatForAdmin";


const { Title } = Typography;
const DataInsights = () => {

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(false);
    }, []);

    return (
        <Spin spinning={loading}>
            <SidebarLayout>

                <div>
                    <EchoChatForAdmin />

                </div>
            </SidebarLayout>
        </Spin>
    );
};

export default DataInsights;